import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';

import { Form as FormFinal, Field } from 'react-final-form';
import { Button, Alert, Card, Form, Col, Spinner, Table } from 'react-bootstrap';
import { CommentEdit } from '@styled-icons/boxicons-regular/CommentEdit';

//Actions
import { pesquisa as pesquisatermos, novoatualiza as novoatualizatermos, pesquisaTipos } from '../../../../actions/termos/modelos';

//Components
import { camposelectsearch, campoeditor } from '../../../../components/forms/campos/campos';

//Utils
import { getEvento } from '../../../../utils/eventosession';

//Helpers
import { TelaModalLivre } from '../../../../helpers/TelaModal';

const FormTermosGerenciamento  = (props) => {
    
    const [showGravado, handleCloseModalGravado] = useState(false);
    const [modeloscadastrados, setModelosEvento] = useState(false);    
    const [tipos, setTipos] = useState(false);

    const evento = getEvento();

    useEffect(() => {
        load();        
    },[]);
    
    useEffect(() => {
        load();
    },[props.novoatualiza]);

    const load = async () => {
        const result = await props.pesquisatermos({idevento: evento.idevento, idpromotora: evento.idpromotora});
        setModelosEvento(result&&result.length?result.filter(itens => (itens.idevento!==1)):false);
        setTipos(await props.pesquisaTipos({idpromotora: evento.idpromotora}));
    }
        
    const handleSubmit = async (dadosform, form) => {
        const dados = {
            idevento: evento.idevento,
            idpromotora: evento.idpromotora,
            ...dadosform
        }
        
        await props.novoatualizatermos(dados);
        setTimeout(() => {
            form.reset();
            load();
            handleCloseModalGravado(true);
        },500);
    }
    
    const handleModalGravado = () => {
        handleCloseModalGravado(showGravado?false:true);        
    }

    const handleTipoSelecionado = (idtermostipos,form) => {

        const dados = modeloscadastrados!==false?modeloscadastrados.filter(itens => {
            if(itens.idevento!==1){
                return itens.idevento!==1&&itens.idtermostipos===idtermostipos;
            }else{
                return itens.idtermostipos===idtermostipos;
            }
        }):false;

        if(dados[0]){
            form.change('portugues', dados[0].portugues);
            form.change('ingles', dados[0].ingles);
            form.change('espanhol', dados[0].espanhol);
            form.change('idtermostipos', idtermostipos);
            form.change('idfaq', dados[0].idevento===1?'':dados[0].idfaq);
        }else{
            form.change('portugues', '');
            form.change('ingles', '');
            form.change('espanhol', '');
            form.change('idfaq', '');
            form.change('idtermostipos', idtermostipos);
        }
    }

    const handleResetForm = (form) => {        
        form.reset();
        setTipos({});
    }
    console.log(modeloscadastrados)
    return (
        <>        
        <FormFinal
        onSubmit={handleSubmit}
        validate={(form) => {
            const errors = {};
            if(!form.portugues){
                errors.portugues = 'Obrigatório';
            }
            if(!form.idtermostipos){
                errors.idtermostipos = 'Obrigatório';
            }
        }}
        render={({form, handleSubmit, submitting, submitSucceeded}) => {            
            return (                
                <Card>                        
                    <Card.Header><Card.Title>Edição de Termos</Card.Title></Card.Header>
                    <TelaModalLivre handleCloseModal={handleModalGravado} show={showGravado} titulo="Palavras chaves">
                        <Alert variant="success">Gravado com sucesso</Alert>
                    </TelaModalLivre>                    
                    <Card.Body>      
                        {modeloscadastrados!==false?
                        <Table striped bordered hover className="col col-lg-4">
                            <thead>
                                <tr>                            
                                <th>Modelo</th>
                                <th>Editar</th>                            
                                </tr>
                            </thead>                        
                            <tbody>
                                {modeloscadastrados.map(itens => {
                                    if(!itens.tipo){
                                        return false;
                                    }
                                    return (
                                        <tr key={itens.idfaq}>
                                            <td>{itens.tipo.descricao}</td>
                                            <td><CommentEdit style={{cursor: "pointer"}} size="35" type="button" onClick={() => handleTipoSelecionado(itens.idtermostipos, form)} /></td>
                                        </tr>
                                    );
                                })}
                            </tbody>
                        </Table>
                        :
                        null
                        }                  
                        <form onSubmit={(dados) => (handleSubmit(dados,form))}>                            
                            <Form.Row>                            
                                <Form.Group controlId="idtermostipos" as={Col} md="8">
                                    <Field name="idtermostipos" id="idtermostipos" label="Selecione o Tipo de Termo" component={camposelectsearch}
                                        options={tipos!==false&&tipos!==undefined?tipos.map((itens) => ({id: itens.idtermostipos, label: itens.descricao})):false}
                                        placeholder="Selecione o tipo"
                                        form={form}
                                        onChange={(value) => {
                                            handleTipoSelecionado(value, form)
                                        }}
                                    />
                                </Form.Group>                            
                            </Form.Row>                            
                            <Form.Row>    
                                <Form.Group controlId="portugues" as={Col} md="8">
                                    <Field name="portugues" label="Português" component={campoeditor} form={form} />
                                </Form.Group>
                            </Form.Row>
                            <Form.Row>    
                                <Form.Group controlId="ingles" as={Col} md="8">
                                    <Field name="ingles" label="Inglês" component={campoeditor} form={form} />
                                </Form.Group>
                            </Form.Row>
                            <Form.Row>    
                                <Form.Group controlId="espanhol" as={Col} md="8">
                                    <Field name="espanhol" label="Espanhol" component={campoeditor} form={form} />
                                </Form.Group>
                            </Form.Row>
                            <Form.Row className="text-center">
                                <Form.Group controlId="corpo" as={Col} md="8">
                                    <Button 
                                    type="submit"
                                    block
                                    disabled={submitting}
                                    >
                                        {submitting?<Spinner animation="border" />:'Confirmar'}
                                    </Button>
                                    <Button 
                                    type="button" 
                                    onClick={() => {
                                        handleResetForm(form);
                                    }}
                                    block                                    
                                    >
                                        Novo
                                    </Button>
                                </Form.Group>
                            </Form.Row>
                        </form>
                    </Card.Body>
                </Card>                
            )
        }}
        >
        </FormFinal>
        </>
    );
}

const mapStateToProps = (state) => {
    return {        
        pendingTasks: state.pendingTasks,        
    }
}

export default connect(mapStateToProps, { pesquisatermos, novoatualizatermos, pesquisaTipos })(FormTermosGerenciamento);